import React, { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

const DebugStatusPanel = () => {
  const { 
    authStatus, 
    isAuthenticated, 
    ensName, 
    address,
    integrationStatus = 'ready' // Default if not in context
  } = useContext(AuthContext);

  // Format wallet address for display
  const formatWalletAddress = (addr) => {
    if (!addr) return 'None';
    return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
  };

  // Get auth status display text
  const getAuthStatusText = () => {
    if (isAuthenticated && ensName) return 'authenticated';
    if (address && !ensName) return 'wallet-loaded';
    return authStatus || 'idle';
  };

  // Get integration status display text
  const getIntegrationStatusText = () => {
    if (integrationStatus === 'wallet-unlocked' && isAuthenticated) return 'authenticated';
    if (integrationStatus === 'wallet-unlocked' && address) return 'wallet-unlocked';
    if (address && !isAuthenticated) return 'ens-checking';
    return integrationStatus || 'ready';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: '#333',
      color: '#fff',
      padding: '10px',
      borderRadius: '5px',
      fontSize: '12px',
      zIndex: 10000,
      maxWidth: '300px',
      border: '1px solid #FFD700',
      fontFamily: 'monospace',
      lineHeight: '1.4',
      opacity: '0.95',
      backdropFilter: 'blur(5px)'
    }}>
      <div style={{ marginBottom: '4px', borderBottom: '1px solid #555', paddingBottom: '4px' }}>
        <strong>Zpost.ai Status</strong>
      </div>
      <div><strong>Auth Status:</strong> {getAuthStatusText()}</div>
      <div><strong>Connected:</strong> {isAuthenticated ? 'Yes' : 'No'}</div>
      <div><strong>ENS:</strong> {ensName || 'None'}</div>
      <div><strong>Wallet:</strong> {address ? formatWalletAddress(address) : 'None'}</div>
      <div><strong>Integration:</strong> {getIntegrationStatusText()}</div>
      <div style={{ 
        marginTop: '4px', 
        paddingTop: '4px', 
        borderTop: '1px solid #555',
        fontSize: '10px',
        color: '#FFD700',
        textAlign: 'center'
      }}>
        ENS Required: *.zpost.eth
      </div>
    </div>
  );
};

export default DebugStatusPanel;
